import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const TransactionalLog = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title={"Tablero de Control \\ Bitácora \\ Folio: " + props.loanId}/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            label="Cerrar"
                            style={{'float': 'right'}}
                            onClick={props.handleReturnButton}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <SubtitleLabel header="Transacciones " isBold={true}/>

                            <DataTable
                                value={props.transactionLogList}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column field="status" header="Estatus"
                                        style={{textAlign: 'left'}}/>
                                <Column field="description" header="Descripción"
                                        style={{textAlign: 'left'}}/>
                                <Column field="dateLog" header="Fecha"
                                        style={{textAlign: 'left'}}/>
                            </DataTable>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default TransactionalLog;